






























































































import Vue from "vue";
export default Vue.extend({
  props: ["screen"],
  data() {
    return {
      show: true,
      screenHeight: document.documentElement.clientHeight,     // 当前高度
      originHeight: document.documentElement.clientHeight,     //默认高度，用作比较
      userClose: false,
    }
  },
  watch: {
    screenHeight (val) {
      if(this.userClose) return
      if(this.originHeight - val>60) {    //这里以防万一改了下判断形式，当屏幕高度减少了60px以上时才隐藏footer
        this.show = false;
      }else{
        this.show = true;
      }
    }
  },
  computed: {
    iphoneXIs() {
      if (/iphone/gi.test(window.navigator.userAgent)) {
        /* iPhone X、iPhone XS */
        const x = window.screen.width === 375 && window.screen.height === 812;
        /* iPhone XS Max */
        const xsMax = window.screen.width === 414 && window.screen.height === 896;
        /* iPhone XR */
        const xR = window.screen.width === 414 && window.screen.height === 896;
        if (x || xsMax || xR) {
          return true;
        }
        return false;
      }
      return false;
    },
  },
  mounted(){
    window.onresize = () => {
      return (() => {
        this.screenHeight = document.documentElement.clientHeight;
      })()
    }
  },
  methods: {
    download() {
      this.$emit("statistics", "点击", "立即下载");
      this.$emit("openHFQ");
    },
    close() {
      this.userClose = true;
      this.show = false;
    }
  },
});
